import React from 'react';
import { processSteps } from '../data/site';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Process() {
  return <section className="w-full bg-mist py-24 lg:py-32" data-id="element-305" data-mp="1ufg3yq3ly1vq">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-306" data-mp="1ygi7vk8gz241">
        <Reveal data-id="element-307" data-mp="23e1ourwjxszo">
          <SectionHeading label="Our Process" align="center" title="How it works" description="Four clear stages, so you always know where the project stands and what happens next." data-id="element-308" data-mp="23ejs48hmt7h3" />
        </Reveal>

        <div className="relative mt-20" data-id="element-309" data-mp="1an9rhr3r2yar">
          <div className="absolute left-6 top-0 hidden h-full w-px bg-mist-200 sm:block lg:left-0 lg:top-6 lg:h-px lg:w-full" aria-hidden="true" data-id="element-310" data-mp="1fno3fk8h2se2" />

          <ol className="grid gap-12 sm:gap-14 lg:grid-cols-4 lg:gap-8" data-id="element-311" data-mp="1khigi4tko946">
            {processSteps.map((step, i) => <Reveal as="li" key={step.index} delay={i * 0.12} className="relative pl-20 lg:pl-0 lg:pt-20" data-id="element-312" data-mp="ryv3zdsn62ep" data-mpi={i}>
                <span className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center bg-navy font-mono text-xs font-bold tracking-[0.14em] text-white lg:h-12 lg:w-12" data-id="element-313" data-mp="19lr3f2ofscnp">
                  {step.index}
                </span>
                <h3 className="font-heading text-2xl font-extrabold uppercase tracking-tight text-navy" data-id="element-314" data-mp="10rme4noyb9aa">
                  {step.title}
                </h3>
                <p className="mt-4 max-w-xs text-sm leading-relaxed text-mist-600" data-id="element-315" data-mp="quhuovmhprx6">{step.text}</p>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}